import { useTranslation } from 'react-i18next';

import { useAuthenticatedUser } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { PageType } from '@treams/treams-network';
import { Jumbo } from '@treams/treams-ui';

import FeedbackRequestModals from '../packages/kakapo-ui-application/pages/feedback-v2/requests/FeedbackRequestModals';
import IncomingFeedbackList from './IncomingFeedbackList';
import ViewerFeedbackButtons from './ViewerFeedbackButtons';
import ViewerFeedbackTabs from './ViewerFeedbackTabs';

export default function ViewerFeedback() {
	const { t } = useTranslation();

	const viewer = useAuthenticatedUser();
	const userID = viewer.id;

	const query = graphql.useFeedbackRequestsQuery({
		variables: { userID, last: 10, isArchived: false },
	});
	const [fetchArchived, archivedQuery] = graphql.useFeedbackRequestsLazyQuery({
		variables: { userID, last: 10, isArchived: true },
	});

	return (
		<>
			<Jumbo.Editable
				hasMediaUpload
				page={PageType.FeedbackReceived}
				title={t('feedback.index.title')}
				description={t('feedback.index.description')}
				button={<ViewerFeedbackButtons />}
				footer={<ViewerFeedbackTabs />}
			/>

			<IncomingFeedbackList
				query={query}
				userID={userID}
				archivedQuery={archivedQuery}
				fetchArchived={fetchArchived}
			/>

			<FeedbackRequestModals userID={userID} refetch={query.refetch} />
		</>
	);
}
